import { BaseHttpServiceService } from 'src/app/sharedFeatures/services/base-http-service.service';
import { GenericResultModel } from './../../../sharedFeatures/models/generic-result.model';
import { Pagination } from './../../../sharedFeatures/models/pagination.model';
import { CurrentUserService } from './../../../sharedFeatures/services/current-user.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

import { NotificationLightViewModel } from '../Models/Notification-light-view-model.model';
import { NotificationViewModel } from '../Models/Notification-view-model.model';
import { NotificationViewViewModel } from '../Models/Notification-view-view-model.model';
import { NotificationLookupViewModel } from '../Models/Notification-lookup-view-model.model';
import { NotificationSearchModel } from '../Models/Notification-search-model.model';
import { NotificationsByUserId } from '../Models/NotificationsByUserIdAsync';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService extends BaseHttpServiceService {
  showErrorTranslated(arg0: string, error: any) {
    throw new Error('Method not implemented.');
  }

  constructor(
    private http: HttpClient,
    private translateService: TranslateService,
    currentUserService: CurrentUserService
  ) {
    super(http, translateService, currentUserService);
  }

  search(
    model: NotificationSearchModel
  ): Observable<GenericResultModel<NotificationLightViewModel[]>> {
    // Use ChecklistFlow API endpoint (same as original MVC version)
    let url: string = `${this.mysteryShopperUrl}/Notification/GetNotifications`;

    // Map response from ChecklistFlow GlobalResponse format to GenericResultModel
    return this.postData<any>(url, model).pipe(
      map((response: any) => {
        // ChecklistFlow returns GlobalResponse<List<UINotificationDTO>>
        // with format: { resultCode: 9, data: [...], message: "" }
        const dataArray = response.data || [];
        const pagination = Pagination.newPagination(
          0, // pageIndex
          model.count || 20, // pageSize
          dataArray.length, // totalCount
          true // getTotalCount
        );

        const result: GenericResultModel<NotificationLightViewModel[]> = {
          collection: dataArray,
          pagination: pagination,
          data: dataArray, // Required by GenericResultModel
        };

        return result;
      })
    );
  }

  getLight(
    pageIndex?: number,
    pageSize?: number
  ): Observable<GenericResultModel<NotificationLightViewModel[]>> {
    let url: string = `${this.baseUrl}/Notifications/get-light-collection/${pageIndex}/${pageSize}`;
    return this.getData<GenericResultModel<NotificationLightViewModel[]>>(url);
  }

  getLookup(): Observable<GenericResultModel<NotificationLookupViewModel[]>> {
    let url: string = `${this.baseUrl}/Notifications/get-lookup-collection`;
    return this.getData<GenericResultModel<NotificationLookupViewModel[]>>(url);
  }

  getLookupPaged(
    pageIndex?: number,
    pageSize?: number
  ): Observable<GenericResultModel<NotificationLookupViewModel[]>> {
    let url: string = `${this.baseUrl}/Notifications/get-lookup-collection/${pageIndex}/${pageSize}`;
    return this.getData<GenericResultModel<NotificationLookupViewModel[]>>(url);
  }

  getById(id: any): Observable<NotificationViewModel> {
    let url: string = `${this.baseUrl}/Notifications/get/${id}`;
    return this.getData<NotificationViewModel>(url);
  }

  getViewById(id: any): Observable<NotificationViewViewModel> {
    let url: string = `${this.baseUrl}/Notifications/get-view/${id}`;
    return this.getData<NotificationViewViewModel>(url);
  }

  add(model: NotificationViewModel): Observable<NotificationViewModel> {
    let url: string = `${this.baseUrl}/Notifications/add`;
    return this.postData<NotificationViewModel>(url, model);
  }

  update(model: NotificationViewModel): Observable<NotificationViewModel> {
    let url: string = `${this.baseUrl}/Notifications/update`;
    return this.postData<NotificationViewModel>(url, model);
  }

  delete(id: any): Observable<any> {
    let url: string = `${this.baseUrl}/Notifications/delete/${id}`;
    return this.postData<any>(url, null);
  }

  GetAllNotificationsByUserIdAsync(
    pageIndex: number,
    pageSize: number,
    userId: number,
    sortingType: string
  ): Observable<NotificationsByUserId> {
    let url: string = `${this.baseUrl}/NotificationDetails/GetAllNotificationsByUserIdAsync/${pageIndex}/${pageSize}/${userId}/${sortingType}`;
    return this.getData<NotificationsByUserId>(url);
  }
}
